import { useParams } from "react-router-dom";
import { useState } from "react";

import Subjects from "./Subjects";
import client from "../../../../../shared/api/client";
import Loader from "../../../../../shared/components/Loader";
import { handleToast } from "../../../../../shared/utils/functions";
import handleApiError from "../../../../../shared/hooks/handleApiError";
import FormButton from "../../../../../shared/components/form/FormButton";
import useFetchClassSubjects from "../../../../../shared/api/class/subjects/useFetchClassSubjects";

const NewScorecard = ({
  action,
  reportCard,
  fetchReportCard,
  handleCancelNewScorecard,
}) => {
  const { classId, studentId } = useParams();
  const { loading: subjectLoading, data: subjects } =
    useFetchClassSubjects(classId);

  const [addingScorecard, setAddingScorecard] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);

  async function createScorecard() {
    if (addingScorecard) return;
    if (!selectedSubject) return handleToast("No subject selected", "warning");
    if (!reportCard) return handleToast("No report card selected", "warning");

    try {
      setAddingScorecard(true);

      const res = await client.post("/result/reportcard/scorecard/add", {
        reportCardId: reportCard?.reportCardId,
        classSubjectId: selectedSubject?.classSubjectId,
        studentId,
      });

      handleToast(res.data?.message);

      setSelectedSubject(null);

      fetchReportCard();

      setAddingScorecard(false);
      handleCancelNewScorecard();
    } catch (error) {
      setAddingScorecard(false);
      handleApiError(error);
    }
  }

  function handleSelectSubject(params) {
    setSelectedSubject(params);
  }

  if (action !== "new-scorecard") return null;

  if (subjectLoading) return <Loader loading={subjectLoading} />;

  return (
    <div>
      <div className="mb-3">
        <h2 className="side_page_title !mb-2 capitalize">New Scorecard</h2>
        <p className="text-xs text-independence">
          Select from subjects below to create a new scorecard
        </p>
      </div>

      <Subjects
        subjects={subjects}
        selectedSubject={selectedSubject}
        handleSelectSubject={handleSelectSubject}
        addingScorecard={addingScorecard}
        createScorecard={createScorecard}
      />

      <FormButton
        title={"Cancel"}
        className={"!bg-transparent !text-coral_red !border-coral_red"}
        onClick={() => {
          setSelectedSubject(null);
          handleCancelNewScorecard();
        }}
      />
    </div>
  );
};

export default NewScorecard;
